module.exports = __webpack_public_path__ + "static/media/102-balearic-islands.e5cfd2dc.svg";